import React, { Component } from 'react';
import { Menu, Segment } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'

export default class Problem extends Component {
// const Problem = props => {

state = { activeItem: 'problem' }

handleItemClick = (e, { name }) => this.setState({ activeItem: name })


////////////////import React, { Component } from 'react'
// import { Input, Menu, Segment } from 'semantic-ui-react'
//
// export default class MenuExampleTabularOnTop extends Component {
//   state = { activeItem: 'bio' }
//
//   handleItemClick = (e, { name }) => this.setState({ activeItem: name })
//
//   render() {
//     const { activeItem } = this.state
//
//     return (
//       <div>
//         <Menu attached='top' tabular>
//           <Menu.Item name='bio' active={activeItem === 'bio'} onClick={this.handleItemClick} />
//           <Menu.Item
//             name='photos'
//             active={activeItem === 'photos'}
//             onClick={this.handleItemClick}
//           />
//           <Menu.Menu position='right'>
//             <Menu.Item>
//               <Input
//                 transparent
//                 icon={{ name: 'search', link: true }}
//                 placeholder='Search users...'
//               />
//             </Menu.Item>
//           </Menu.Menu>
//         </Menu>
//
//         <Segment attached='bottom'>
//           <img src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
//         </Segment>
//       </div>
//     )
//   }
// }


/////////////////

render(){
  const { activeItem } = this.state


  return (


      <div>

        <Menu attached='top' tabular>
          <Menu.Item name='problem' active={activeItem === 'problem'} onClick={this.handleItemClick}>Решение проблем</Menu.Item>

        </Menu>
       <Segment attached='bottom'>

                  <h4>Не работает Интернет, что делать?</h4>
            <p>
            При отсутствии подключения к Интернет Вы можете попробовать самостоятельно локализовать проблему, тем самым ускоряя время ее решения сотрудниками ОЦНИТ.<br/>Для диагностики всех неисправностей используется командная строка ("Пуск" - "Все программы" - "Стандартные" - "Командная строка"). После запуска появится черное окно с приглашением к вводу команд.
            </p>
            <h4>Алгоритм решения проблем для пользователей выделенных линий</h4>
            <ol>
            <li><p>
            Для определения настроек существует команда <b>ipconfig /all</b>. Ее необходимо набрать в командной строке и нажать enter. В выводе этой утилиты вым следует найти следующую информацию (в вашем случае числа могут быть другими, но в дальнейших примерах предполагается, что компьютер имеет IP-адрес 85.142.128.59 и адрес основного шлюза 85.142.128.33):<br/></p><p>
            <b>IP-адрес. . . . . . . . .:85.142.128.59</b><br/>
            <b>Маска подсети. . . . :255.255.255.224</b><br/>
            <b>Основной шлюз. . . . :85.142.128.33</b><br/>
            <b>DNS-серверы. . . . . . .:85.142.128.2</b><br/></p><p>
            Убедитесь, что IP-адрес, маска подсети, основной шлюз соответствуют настройкам, полученным от сотрудников ОЦНИТ.<p><b>Адреса DNS-серверов.</b><br/>
            Для подразделений университета: <b>85.142.128.2; 85.142.130.129</b><br/>
            Для коммерческих клиентов: <b>80.78.192.131; 80.78.192.132</b>
            </p>
            </p></li>
            <li>
            <p>Если настройки верны, можно начинать диагностику сети.</p>
            <p>Наберите в командной строке <b>ping 85.142.128.33</b>, вместо 85.142.128.33 подставте адрес своего основного шлюза. Команда выведет четыре строки. Их варианты и значения приведены ниже. Оратите внимание на сообщения, выдаваемые командой ping, они будут описаны только один раз.</p>
            <p>
            <b>Ответ от 85.142.128.33: число байт=32 время&lt;1мс TTL=255 </b> - все нормально, шлюз отвечает. Можно продолжить диагностику и перейти к следующему пункту.
            </p>
            <p>
            <b>Ответ от 85.142.128.33: Заданный узел недоступен </b> - шлюз отвечает, что Вам запрещен доступ к сети. Возможно вы отключены от сети из-за генерации Вашим компьютером огромного количества паразитного трафика или рассылки спама вследствие заражения вирусом. <br/>Обратитесь в ОЦНИТ для проверки этого. В случае подтверждения данного факта рекомендуется выполнить полную проверку компьютера на вирусы и поставить сетевой экран (брандмауэр, firewall). После этого можно обратиться в ОЦНИТ с просьбой о подключении.<br/>Помните, что в случае возобновления генерации паразитного трафика, Вы вновь будете отключены.
            </p>
            <p>
            <b>Ответ от 85.142.128.59: Заданный узел недоступен </b> - в Windows Vista означает отсутствие сетевого подключения (не подключен кабель, отсутствует связь со шлюзом).<br/>Проверьте подключение сетевого кабеля и работоспособность (наличие питания) коммутатора (switch) или концентратора (hub). Если подключен, обратитесь в ОЦНИТ.
            </p>
            <p>
            <b>Аппаратный сбой </b> - в Windows XP означает отсутствие сетевого подключения (не подключен кабель). Действуйте аналогично предыдущему пункту.
            </p>
            <p>
            <b>Превышен интервал ожидания для запроса </b> - в Windows XP означает отсутствие связи со шлюзом. Обратитесь в ОЦНИТ.
            </p>
            </li>
            <li>
            <p>
            Если шлюз отвечает, проверяется отвечает ли сервер DNS командой <b>ping 85.142.128.2</b>, где 85.142.128.2 - адрес DNS сервера. Адреса DNS серверов приведены выше. Ошибки команды ping такие же, как в предыдущем случае. В случае ответа DNS сервера переходите к следующему пункту, в противном случае обратитесь в ОЦНИТ.
            </p>
            </li>
            <li>
            <p>
            Пробуем связаться с хостом локальной сети командой <b>ping tsu.tula.ru</b><br/>
            Если команда выдает сообщение <b>"При проверке связи не удалось обнаружить узел tsu.tula.ru. Проверьте имя узла и повторите попытку."</b>, у вас не настроен или неправильно настроен DNS сервер. Остальные ошибки команды ping описаны выше.<br/>Если узел tsu.tula.ru отвечает переходите к следующему шагу, если нет обратитесь в ОЦНИТ.
            </p>
            </li>
            <li>
            <p>Пробуем связаться с удаленным хостом (Интернет) командой <b>ping ya.ru</b> и смотрим на вывод команды ping</p>
            <p>
            <b>Ответ от 80.78.192.144: Заданный узел недоступен </b> - для пользователей ТулГУ означает, что у них нет договора с ОЦНИТ и их компьютеру запрещен доступ в Интернет.
            </p>
            <p>
            <b>Ответ от 213.180.204.8: число байт=32 время&lt;1мс TTL=255</b> - все работает, а если не работает, проблема в приложениях, установленных на Вашем компьютере или операционной системе.
            </p>
            </li>
            </ol>
        </Segment>

      </div>
  )
}
}

// export default Problem
